import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Mail } from "lucide-react";
import { cn } from "../../../design-system/lib/cn.js";

export default function Footer() {
  return (
    <footer className="bg-[var(--color-warm-900)] text-[var(--color-warm-300)]">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-10">
          {/* Marca */}
          <div>
            <img
              src="/assets/logo-tesourinhos-trans.png"
              alt="Tesourinhos Logo"
              className="h-10 w-auto mb-3 brightness-0 invert opacity-90"
            />
            <p className="text-sm leading-relaxed text-[var(--color-warm-400)]">
              Conectando famílias à babá de confiança com carinho e segurança.
            </p>
            {/* Redes sociais */}
            <div className="flex gap-3 mt-4">
              {[
                { href: "https://www.facebook.com/profile.php?id=61586259446154", Icon: FaFacebook },
                { href: "https://www.instagram.com/tesourinhosbabysitter/", Icon: FaInstagram },
                { href: "https://wa.me/5521996669205?text=Olá,%20gostaria%20de%20mais%20informações", Icon: FaWhatsapp },
              ].map(({ href, Icon }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--color-warm-800)] text-[var(--color-warm-300)] hover:bg-[var(--color-rose-400)] hover:text-white transition-colors"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h5 className="text-sm font-semibold text-[var(--color-warm-100)] uppercase tracking-wide mb-4">
              Links
            </h5>
            <ul className="space-y-2 text-sm">
              {[
                { to: "/#como-funciona", label: "Como Funciona" },
                { to: "/#pacotes", label: "Nossos Pacotes" },
                { to: "/politica-de-privacidade", label: "Política de Privacidade" },
                { to: "/termos-de-uso", label: "Termos de Uso" },
                { to: "/login", label: "Login" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="hover:text-[var(--color-rose-400)] transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h5 className="text-sm font-semibold text-[var(--color-warm-100)] uppercase tracking-wide mb-4">
              Contato
            </h5>
            <a
              href="mailto:carla.tesourinhosadm@gmail.com"
              className="flex items-center gap-2 text-sm hover:text-[var(--color-rose-400)] transition-colors"
            >
              <Mail size={14} /> carla.tesourinhosadm@gmail.com
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[var(--color-warm-800)] pt-6 text-center text-xs text-[var(--color-warm-500)]">
          &copy; {new Date().getFullYear()} Tesourinho's. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}